import ColoredMarker from "./ColoredMarker";
import {
  AppointmentStatusSlug,
  getAppointmentStatusValuesBySlug,
} from "../../_constants/appointment";

type ServiceStatusComponentProps = {
  slug: AppointmentStatusSlug;
  count?: any;
  isActive?: boolean;
};

const ServiceStatusComponent = ({
  slug,
  count,
  isActive = false,
}: ServiceStatusComponentProps) => {
  const { bubbleClass, color, name } = getAppointmentStatusValuesBySlug(slug);

  return (
    <ColoredMarker
      active={isActive}
      className="text-no-wrap"
      color={color}
      count={count}
      bubbleClass={bubbleClass}
    >
      {name}
    </ColoredMarker>
  );
};

export default ServiceStatusComponent;
